import React, {useEffect} from "react";
import VerticalTabs from "./VerticalTabs";
import BasicInformationSri from "./BasicInformationSri";
import {useFindTaxPayer} from "../../services/apis/apiTaxPayer";
import Observations from "../components/observations";
import {useTaxPayerStorage} from "../../services/storage/TaxPayerStorage";

function DashboardRuc() {
    const [openCollapse, setOpenCollapse] = React.useState(true);
    const [errorPage, setErrorPage] = React.useState(false);
    const data = useTaxPayerStorage(data => data.data)

    const {
        mutate: getTaxPayer,
        data: successTaxPayer,
        isPending: loadingTaxPayer,
        error: errorTaxPayer,
    } = useFindTaxPayer()

    useEffect(() => {
        if (successTaxPayer) {
            setErrorPage(false);
        }
    }, [successTaxPayer]);

    useEffect(() => {
        if (errorTaxPayer) {
            setErrorPage(true);
        }
    }, [errorTaxPayer]);

    return(
        <div className={'max-w-[1200px] mx-auto min-h-[80vh] flex flex-col gap-5'}>
            <BasicInformationSri
                viewCollapse={true}
                {...{
                    openCollapse,
                    setOpenCollapse,
                    getTaxPayer,
                    successTaxPayer,
                    loadingTaxPayer,
                    errorTaxPayer
                }}
            />
            {/*{data?.taxIdentificationNumber && <Observations identification={data?.taxIdentificationNumber}/>}*/}
            {!errorPage && <VerticalTabs loading={loadingTaxPayer} {...{setOpenCollapse}}/>}
        </div>
    )
}

export default DashboardRuc
